module.exports = __webpack_public_path__ + "img/topindicator7.10370ade.png";